export function getBeginYearsList() {
  const currentYear = new Date().getFullYear();
  const yearList = [];

  for (let i = currentYear; i >= currentYear - 45; i -= 1) {
    yearList.push(i);
  }
  return yearList;
};